/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleHasGlanceApiRequest } from '../../models/hotel-edit-single-has-glance-api-request';

export interface ApiHotelManageEditSingleGlancePost$Params {
      body: HotelEditSingleHasGlanceApiRequest
}

export function apiHotelManageEditSingleGlancePost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleGlancePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleGlancePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleGlancePost.PATH = '/api/hotel/manage/edit/single/glance';
